const Card = (props: React.ComponentProps<'button'>) => {
    return (
        <button
            {...props}
            className={
                'bg-text-contrast rounded-[5px] overflow-hidden border border-transparent hover:border-primary shadow-sm ' +
                'flex flex-row gap-2.5 w-full px-5 py-4 items-start ' + props.className
            }
        >
            {props.children}
        </button>
    );
};

export default Card;
